<template>
  <div class="container">

    <div v-for="(g, i) of groups" class="panel">
      <div class="panel-header" @click="setGrp(i)">
        <!-- <div class="panel-title">{{g[0].firstname}} {{g[0].lastname}}</div> -->
        <div class="panel-title">{{getTitle(g[0])}}</div>
      </div>

      <div v-if="sel_grp === i" class="panel-body">
        <div v-for="(inv, j) in g" class="tile" :class="{'deleted': deleted_inv === inv._id}">

          <div class="tile-content">
            <p class="tile-title">
              <div class="container c-hand">
                <div class="columns">
                  <div class="column col-1 col-md-4" @click="setInv(j)">
                    {{inv.ref}}
                  </div>
                  <div class="column col-1 col-md-4" @click="setInv(j)">
                    {{date(inv.date)}}
                  </div>
                  <div class="column col-2 col-md-4" @click="setInv(j)">
                    {{inv.matter_desc}}
                  </div>
                  <div class="column col-3 col-md-4">
                    <span v-if="inv.paid" class="label label-success">Paid<span v-if="hasPayment(inv)">: {{date(inv.last_payment)}}</span></span>
                    <span v-else class="label label-warning">Unpaid</span>
                  </div>
                  <div class="column col-3 col-md-4">
                    <span v-if="inv.sendError" class="label label-error">Something went wrong</span>
                  </div>
                </div>
              </div>

              <div class="container">
                <div class="columns">
                  <div class="column col-12 col-md-12" style="padding:1.6em 0">
                    <div class="column col-12">
                      <button class="btn btn-sm" title="Mark as paid/unpaid" @click="togglePaid(inv)">
                        Mark as paid
                      </button>
                      <button class="btn btn-sm" @click="sendInvoice(inv)">
                        Send invoice  <span v-if="inv.sent" class="label label-success"><i class="fa fa-check" aria-hidden="true"></i></span>
                      </button>
                      <button class="btn btn-sm" @click="viewPdf(inv, 'inline')">
                        <i class="fa fa-eye" aria-hidden="true"></i> View Invoice
                      </button>
                      <button class="btn btn-sm" @click="viewPdf(inv, 'attachment')">
                        <i class="fa fa-download" aria-hidden="true"></i> Download
                      </button>
                      <button class="btn btn-sm" @click="copyLink(inv)">
                        <i class="fa fa-clone" aria-hidden="true"></i> Copy Link
                      </button>
                      <button v-if="inv.paid" class="btn btn-sm" @click="viewReceipt(inv)">
                        View receipt
                      </button>
                      <button v-if="inv.paid" class="btn btn-sm" @click="sendReceipt(inv)" :class="{loading: sending === inv}">
                        Send receipt 
                      </button>
                      <button v-if="!inv.paid" class="btn btn-sm" @click="openPaymentModal(inv)">
                        <i class="fa fa-credit-card" aria-hidden="true"></i> Pay
                      </button>
                      <button class="btn btn-sm" @click="del(inv)">
                        <i class="fa fa-trash" aria-hidden="true"></i> Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </p>

            <!-- INVOICE CONTENT -->
            <div v-if="sel_inv === j">

              <table class="table">
                <thead>
                  <tr>
                    <th>Item description</th>
                    <th>Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in inv.items">
                    <td>{{item.description}}</td>
                    <td>${{c2d(item.cost)}}</td>
                  </tr>
                  <tr v-if="inv.gst">
                    <td>GST (10%)</td>
                    <td>${{c2d(inv.gst)}}</td>
                  </tr>
                  <tr v-if="inv.surcharge">
                    <td>Surcharge (1.4%)</td>
                    <td>${{c2d(inv.surcharge)}}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>${{c2d(inv.total)}}</td>
                  </tr>
                </tbody>
              </table>

              <table v-if="inv.plan" class="table">
                <thead>
                  <tr>
                    <th>Payment Plan: ${{c2d(inv.monthly)}} per month</th>
                    <th>Remaining: ${{c2d(inv.outstanding)}}</th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="payment in payments(inv)">
                    <td v-if="inv.last_payment">{{payment.date}}</td>
                    <td v-else>Upcoming</td>
                    <td>${{c2d(payment.amount)}}</td>
                    <td>
                      <span v-if="payment.paid" class="label label-rounded label-success">Paid</span>
                      <span v-else class="label label-rounded label-warning">Scheduled</span>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <!-- END INVOICE CONTENT -->

          </div>



        </div>
      </div>
    </div>

    <!-- INVOICE SENDING MODAL -->
    <sendModal :show="showSendModal"
               :invoice="invoiceToSend"
               v-on:close="showSendModal = false"
               v-on:done="showSendModal = false"></sendModal>

    <payModal :invoice="invoiceToPay" :active="showPayModal" v-on:hide="closePaymentModal"></payModal>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import sendInvoiceModal from '@/components/accounts/sendInvoiceModal'
import paymentModal from '@/components/accounts/paymentModal'

export default {
  name: 'adminInvoices',
  props: ['invoices', 'showOverdue'],
  mixins: [utils],
  components: {
    'sendModal': sendInvoiceModal,
    'payModal': paymentModal
  },
  data () {
    return {
      // invoices: [],
      sel_grp: -1,
      sel_inv: -1,
      showSendModal: false,
      showPayModal: false,
      invoiceToSend: null,
      invoiceToPay: null,
      sending: null, // for the sending spinner (receipts)
      deleted_inv: null // id of the invoice to hide
    }
  },
  computed: {
    groups: function () {
      let m = new Map()
      let period = 1000 * 60 * 60 * 24 * 2 // milliseconds in two weeks
      let now = new Date()

      for (let i of this.invoices) {
        if (this.showOverdue) {
          let then = new Date(i.date)
          if (now - then < period) {
            continue
          }
        }

        if (m.has(i.user)) {
          m.get(i.user).push(i)
        } else {
          m.set(i.user, [i])
        }
      }
      return Array.from(m.values())
    }
  },
  methods: {
    getTitle: function (inv) {
      return inv.business ? inv.business : inv.firstname + ' ' + inv.lastname
    },
    payments: function (inv) {
      return utils.methods.payments(inv)
    },
    date: function (d) {
      return new Date(d).toLocaleDateString()
    },
    hasPayment: function (inv) {
      return new Date(inv.last_payment).getTime() > 0
    },
    setGrp: function (n) {
      this.sel_grp = this.sel_grp === n ? -1 : n
    },
    setInv: function (n) {
      this.sel_inv = this.sel_inv === n ? -1 : n
    },
    c2d: function (c) {
      return (c / 100).toFixed(2)
    },
    viewPdf: function (inv, disposition) {
      // disposition must be either 'inline', for opening in a new tab,
      // or 'attachment', for a save box
      if (!inv.pdf) {
        axios.post('/api/pdf/make/invoices/' + inv._id).then(res => {
          if (res.status === 200) {
            inv.pdf = res.data
            this.viewPdf(inv, disposition)
          }
        })
      } else {
        let filename = 'invoice_' + inv.ref + '.pdf'
        let link = '/api/pdf/get/' + disposition + '/' + inv.pdf + '/' + filename
        window.open(link, '_blank')
      }
    },
    viewReceipt: function (inv) {
      window.open('/api/invoices/getreceipt/' + inv._id, '_blank')
    },
    sendInvoice: function (inv) {
      this.invoiceToSend = inv
      this.showSendModal = true
    },
    sendReceipt: function (inv) {
      this.sending = inv
      inv.sendError = false
      axios.post('/api/invoices/sendreceipt/' + inv._id)
      .then(res => {
        if (res.status === 200) {
          this.sending = null
        }
      })
      .catch(e => {
        this.sending = null
        inv.sendError = true
        console.log(e.response.data)
      })
    },
    togglePaid: function (inv) {
      let form = new FormData()
      form.append('id', inv._id)
      form.append('paid', inv.paid)

      axios.post('/api/invoices/togglepaid/', form)
      .then(res => {
        if (res.status === 200) {
          inv.paid = !inv.paid
        }
      })
    },
    copyLink: function (inv) {
      let link = window.location.origin + '/#/invoices/' + inv._id
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link)
      } else { // Firefox
        let el = document.getElementById(inv._id)
        let textArea = document.createElement('textarea')
        textArea.value = link
        el.appendChild(textArea)
        textArea.focus()
        textArea.select()
        document.execCommand('copy')
        el.removeChild(textArea)
      }
    },
    del: function (inv) {
      this.deleted_inv = inv._id // so we can fade the invoice tile
      axios.post('/api/invoices/delete/' + inv._id)
      .then(res => {
        if (res.status === 200) {
          this.$emit('del')
        }
      })
    },
    openPaymentModal: function (inv) {
      this.invoiceToPay = inv
      this.showPayModal = true
    },
    closePaymentModal: function () {
      this.showPayModal = false
      this.invoiceToPay = null
    }
  }
}
</script>
<style scoped>
.panel {
  border-bottom:none;
}
.panel:nth-child(2n) .panel-header {
  background: #f6f7f9;
}
.panel:first-child {
  border-top: none;
}
.panel:last-child {
  border-bottom: .05rem solid #e7e9ed;
  margin-bottom: 4em
}
.panel-header {
  cursor: pointer;
}
a i.fa.fa-link {
    color: #222;
}
.tile:nth-child(n+2) {
    border-top: 1px solid #e7e9ed;
}
.deleted {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0.3s, opacity 0.3s;
}
</style>



// WEBPACK FOOTER //
// adminInvoices.vue?05dda49a